import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { dashboardColors } from "./theme";

interface GrowthItem {
  orders: number;
}

interface GrowthIndicatorOptions {
  iconSize?: "small" | "medium";
  textSize?: "xs" | "sm";
  useThemeColors?: boolean;
}

export function getGrowthIndicator<T extends GrowthItem>(
  current: T,
  previous?: T,
  options: GrowthIndicatorOptions = {}
): React.ReactElement | null {
  const {
    iconSize = "medium",
    textSize = "sm",
    useThemeColors = true,
  } = options;

  if (!previous) return null;

  const iconClass = iconSize === "small" ? "h-3 w-3" : "h-4 w-4";
  const textClass = `text-${textSize}`;

  if (previous.orders === 0) {
    if (current.orders > 0) {
      const colorStyle = useThemeColors
        ? { color: dashboardColors.success }
        : undefined;
      const colorClass = !useThemeColors ? "text-green-600" : "";

      return (
        <div
          className={`flex items-center ${textClass} ${colorClass}`.trim()}
          style={colorStyle}
        >
          <TrendingUp className={`${iconClass} mr-1`} />
          <span>nouveau</span>
        </div>
      );
    }
    return null;
  }

  const growth = ((current.orders - previous.orders) / previous.orders) * 100;

  if (growth > 0) {
    const colorStyle = useThemeColors
      ? { color: dashboardColors.success }
      : undefined;
    const colorClass = !useThemeColors ? "text-green-600" : "";

    return (
      <div
        className={`flex items-center ${textClass} ${colorClass}`.trim()}
        style={colorStyle}
      >
        <TrendingUp className={`${iconClass} mr-1`} />
        <span>+{growth.toFixed(0)}%</span>
      </div>
    );
  } else if (growth < 0) {
    const colorStyle = useThemeColors
      ? { color: dashboardColors.danger }
      : undefined;
    const colorClass = !useThemeColors ? "text-red-600" : "";

    return (
      <div
        className={`flex items-center ${textClass} ${colorClass}`.trim()}
        style={colorStyle}
      >
        <TrendingDown className={`${iconClass} mr-1`} />
        <span>{growth.toFixed(0)}%</span>
      </div>
    );
  }
  return null;
}
